/*
 * DADD'E — editorial "Ken Burns" reveal-zoom (2026-08).
 * Loaded only on the homepage (see layout/theme.liquid, gated to
 * template == 'index', same as dadde-homepage.css).
 *
 * Toggles .is-revealed on each [data-dadde-zoom] element the first time
 * it scrolls into view; the actual scale animation is pure CSS
 * (assets/dadde-homepage.css) via a single transitioned transform, not a
 * per-frame scroll calculation — deliberately, so this can't contribute
 * to the "stuck"/janky scroll feel the animation is meant to fix
 * alongside.
 *
 * Fires once per element (unobserve after reveal) — re-triggering on
 * every scroll up/down risked looking glitchy on a fast back-and-forth
 * scroll, so each image settles once and stays there.
 */
(function () {
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var targets = document.querySelectorAll('[data-dadde-zoom]');
    if (!targets.length) return;

    // Reduced motion: CSS already disables the transform/transition, so
    // there is nothing left to animate — skip the observer entirely.
    if (reduceMotion) return;

    if (!('IntersectionObserver' in window)) {
      // No observer support: just show images in their settled state
      // rather than leaving them permanently zoomed.
      targets.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
